import React from 'react';
import { Col, Container, Row,Button, ButtonToolbar,} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/createNew';

/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const createNew = ({ t }) => (
  <Container>
    <Row>
      <Col md={10}>
        <h3 className="page-title">Cycle Count Dashboard</h3>
      </Col>
	 
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

createNew.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(createNew);
